import { Colors } from '../../../../shared/theme';

export default {
  defaultContent: {
    backgroundColor: Colors.white,
    padding: 20
  } as React.CSSProperties,
};
